export const ErrorCodes = {
  BAD_REQUEST: 'BAD_REQUEST',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  RATE_LIMITED: 'RATE_LIMITED',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  NOT_IMPLEMENTED: 'NOT_IMPLEMENTED',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  INVALID_INPUT: 'INVALID_INPUT',
  MISSING_PARAMETER: 'MISSING_PARAMETER',
  RESOURCE_EXISTS: 'RESOURCE_EXISTS',
  RESOURCE_EXPIRED: 'RESOURCE_EXPIRED',
  DEPENDENCY_FAILURE: 'DEPENDENCY_FAILURE',
  EXTERNAL_PROVIDER_ERROR: 'EXTERNAL_PROVIDER_ERROR',
  WEBHOOK_VERIFICATION_FAILED: 'WEBHOOK_VERIFICATION_FAILED',
  SSO_AUTHENTICATION_FAILED: 'SSO_AUTHENTICATION_FAILED',
  SIS_SYNC_FAILED: 'SIS_SYNC_FAILED',
  ENCRYPTION_ERROR: 'ENCRYPTION_ERROR',
  BACKUP_IN_PROGRESS: 'BACKUP_IN_PROGRESS',
  QUOTA_EXCEEDED: 'QUOTA_EXCEEDED',
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
  CORS_ORIGIN_DENIED: 'CORS_ORIGIN_DENIED',
} as const

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes]

export const ErrorStatusMap: Record<ErrorCode, number> = {
  [ErrorCodes.BAD_REQUEST]: 400,
  [ErrorCodes.UNAUTHORIZED]: 401,
  [ErrorCodes.FORBIDDEN]: 403,
  [ErrorCodes.NOT_FOUND]: 404,
  [ErrorCodes.CONFLICT]: 409,
  [ErrorCodes.RATE_LIMITED]: 429,
  [ErrorCodes.INTERNAL_ERROR]: 500,
  [ErrorCodes.NOT_IMPLEMENTED]: 501,
  [ErrorCodes.VALIDATION_ERROR]: 400,
  [ErrorCodes.INVALID_INPUT]: 400,
  [ErrorCodes.MISSING_PARAMETER]: 400,
  [ErrorCodes.RESOURCE_EXISTS]: 409,
  [ErrorCodes.RESOURCE_EXPIRED]: 410,
  [ErrorCodes.DEPENDENCY_FAILURE]: 502,
  [ErrorCodes.EXTERNAL_PROVIDER_ERROR]: 502,
  [ErrorCodes.WEBHOOK_VERIFICATION_FAILED]: 401,
  [ErrorCodes.SSO_AUTHENTICATION_FAILED]: 401,
  [ErrorCodes.SIS_SYNC_FAILED]: 500,
  [ErrorCodes.ENCRYPTION_ERROR]: 500,
  [ErrorCodes.BACKUP_IN_PROGRESS]: 409,
  [ErrorCodes.QUOTA_EXCEEDED]: 429,
  [ErrorCodes.ACCOUNT_LOCKED]: 423,
  [ErrorCodes.CORS_ORIGIN_DENIED]: 403,
}
